import router from "@/router";
import MADTemplateService from "@/services/mad.template.service";
import AppService from "@/services/app.service";
import {getField, updateField} from "vuex-map-fields";
import Vue from "vue";
import i18n from "@/plugins/i18n";
const state = () => ({
    listTemplate: [],
    loading: false,
});
const mutations = {
    openLoading(state) {
        state.loading = true;
    },
    closeLoading(state) {
        state.loading = false;
    },
    setListTemplate(state, payload) {
        state.listTemplate = payload
    },
    updateMADTemplate (state, data) {
        const idx = state.listTemplate.findIndex(o => o._id === data._id)
        Vue.set(state.listTemplate, idx, data)
    },
    deleteMADTemplate (state, data) {
        const idx = state.listTemplate.findIndex(o => o._id === data._id)
        Vue.delete(state.listTemplate, idx)
    },
    createMADTemplate(state, data) {
        state.listTemplate.unshift(data)
    },
    bindFormData (state, data) {
        if (typeof data === 'object') {
            for (const propName in data) {
                state[propName] = data[propName]
            }
        }
    },
    setType(state, data) {
        state.type = data
    },
    updateField
};
const actions = {
    bindUpdateForm({commit}, data) {
        commit('bindFormData', data)
    },
    getAllTemplate({commit}) {
        let botCode = router.currentRoute.params.bot_code;
        if (!botCode) {
            return
        }
        commit('openLoading');
        MADTemplateService.findAll(botCode)
            .then(res => {
                commit('setListTemplate', res.data.results)
            })
            .finally(() => {
                commit("closeLoading")
            })
    },
    createMADTemplate({dispatch, commit}, data) {
        dispatch('loading/openLoading', null, {root: true});
        let botCode = router.currentRoute.params.bot_code;
        MADTemplateService.create(botCode, data)
            .then((res) => {
                commit('createMADTemplate', res.data)
                AppService.toastInfo(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
            .finally(() => {
                dispatch('loading/closeLoading', null, {root: true});
                dispatch('dialog/closeDialogCreateMADTemplate', null, {root: true});
            })
    },
    updateMADTemplate({dispatch, commit}, data) {
        dispatch('loading/openLoading', null, {root: true});
        let botCode = router.currentRoute.params.bot_code;
        MADTemplateService.update(botCode, data)
            .then((res) => {
                commit('updateMADTemplate', res.data)
                AppService.toastInfo(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
            .finally(() => {
                dispatch('loading/closeLoading', null, {root: true});
                dispatch('dialog/closeDialogUpdateMADTemplate', null, {root: true});
            })
    },
    deleteMADTemplate({dispatch, commit}, data) {
        let botCode = router.currentRoute.params.bot_code;
        Vue.$confirm(
            {
                message: i18n.t('areYouSureDelete'),
                button: {
                    no: i18n.t('cancel'),
                    yes: i18n.t('ok'),
                },
                callback: confirm => {
                    if (confirm) {
                        dispatch('loading/openLoading', null, { root: true })
                        MADTemplateService.deleteOne(botCode, data._id).then(res => {
                            commit('deleteMADTemplate', res.data)
                            AppService.toastInfo(i18n.t('success'))
                        }).catch(() => {
                            AppService.toastError(i18n.t('failed'))
                        }).finally(() => {
                            dispatch('loading/closeLoading', null, { root: true })
                        })
                    }
                },
            },
        )
    },

};
const getters = {
    getField,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
